var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThemeColor(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_111485_195892",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_111485_195892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H38C39.1046 0 40 0.895431 40 2V3H0V0Z",
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.45215,
    cy: 1.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.45215,
    cy: 1.5,
    r: 0.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.45215,
    cy: 1.5,
    r: 0.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C12 4.44772 12.4477 4 13 4H38C38.5523 4 39 4.44772 39 5V7C39 7.55228 38.5523 8 38 8H13C12.4477 8 12 7.55228 12 7V5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3H11V40H2C0.895431 40 0 39.1046 0 38V3Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 7C3.32843 7 4 6.32843 4 5.5C4 4.67157 3.32843 4 2.5 4C1.67157 4 1 4.67157 1 5.5C1 6.32843 1.67157 7 2.5 7Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.5C5 5.22386 5.22386 5 5.5 5H9.5C9.77614 5 10 5.22386 10 5.5C10 5.77614 9.77614 6 9.5 6H5.5C5.22386 6 5 5.77614 5 5.5Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 9.5C10 9.22386 9.77614 9 9.5 9H1.5C1.22386 9 1 9.22386 1 9.5C1 9.77614 1.22386 10 1.5 10H9.5C9.77614 10 10 9.77614 10 9.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.5C10 11.2239 9.77614 11 9.5 11H1.5C1.22386 11 1 11.2239 1 11.5C1 11.7761 1.22386 12 1.5 12H9.5C9.77614 12 10 11.7761 10 11.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.5C10 13.2239 9.77614 13 9.5 13H1.5C1.22386 13 1 13.2239 1 13.5C1 13.7761 1.22386 14 1.5 14H9.5C9.77614 14 10 13.7761 10 13.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.5C10 15.2239 9.77614 15 9.5 15H1.5C1.22386 15 1 15.2239 1 15.5C1 15.7761 1.22386 16 1.5 16H9.5C9.77614 16 10 15.7761 10 15.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.5C10 17.2239 9.77614 17 9.5 17H1.5C1.22386 17 1 17.2239 1 17.5C1 17.7761 1.22386 18 1.5 18H9.5C9.77614 18 10 17.7761 10 17.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 19.5C10 19.2239 9.77614 19 9.5 19H1.5C1.22386 19 1 19.2239 1 19.5C1 19.7761 1.22386 20 1.5 20H9.5C9.77614 20 10 19.7761 10 19.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21.5C10 21.2239 9.77614 21 9.5 21H1.5C1.22386 21 1 21.2239 1 21.5C1 21.7761 1.22386 22 1.5 22H9.5C9.77614 22 10 21.7761 10 21.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 23.5C10 23.2239 9.77614 23 9.5 23H1.5C1.22386 23 1 23.2239 1 23.5C1 23.7761 1.22386 24 1.5 24H9.5C9.77614 24 10 23.7761 10 23.5Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 36.5C12 36.2239 12.2239 36 12.5 36H38.5C38.7761 36 39 36.2239 39 36.5V38.5C39 38.7761 38.7761 39 38.5 39H12.5C12.2239 39 12 38.7761 12 38.5V36.5Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeColor);
export default __webpack_public_path__ + "static/media/theme-color.496e2bf9e4a412137ef3bbde4f304dac.svg";
export { ForwardRef as ReactComponent };